import { useEffect, useMemo, useRef, useState } from 'react';
import './StudentLifePage.css';

import treeImage from './assets/Tree_for_Character_Shaping_Program.png';

import heroSlide1 from './assets/SLHero_FirstDay.png';

import heroSlide2 from './assets/SLHero_IMG3999.jpg';

import heroSlide3 from './assets/SLHero_StudentsLife.jpg';

import clubImage1 from './assets/news/news1.jpg';

import clubImage2 from './assets/news/news3.jpg';

import clubImage3 from './assets/news/news4.jpg';

import clubImage4 from './assets/news/news6.jpg';

import clubImage5 from './assets/news/news7.jpg';

import clubECASport from './assets/ClubECA_Sport_1.jpeg';
import clubECAArt from './assets/ClubECA_Arts_1.jpg';
import clubECALeadership from './assets/ClubECA_Leadership_1.jpg';
import clubECALanguage from './assets/ClubECA_Language_1.JPG';
import clubECASport2 from './assets/ClubECA_Sport_2.png';
import clubECAArt2 from './assets/ClubECA_Arts_2.png';
import clubECALeadership2 from './assets/ClubECA_Leadership_2.jpg';
import clubECALanguage2 from './assets/ClubECA_Language_2.jpg';

import eventSpartan1 from './assets/EventComp_Spartan_1.jpg';
import eventSpartan2 from './assets/EventComp_Spartan_2.JPG';
import eventEntrepreneur1 from './assets/EventComp_Enterprenuer_1.jpeg';
import eventEntrepreneur2 from './assets/EventComp_Enterprenuer_2.jpeg';
import eventInnovation1 from './assets/EventComp_Innovation_1.png';

import houseSystemCourage from './assets/HouseSystem_Courage.png';
import houseSystemFaith from './assets/HouseSystem_Faith.png';
import houseSystemHope from './assets/HouseSystem_Hope.png';
import houseSystemLove from './assets/HouseSystem_Love.png';
import houseSystemPeace from './assets/HouseSystem_Peace.png';

import wellbeingSEL1 from './assets/Wellbeing_SEL_1.jpg';
import wellbeingSEL2 from './assets/Wellbeing_SEL_2.jpg';
import wellbeingSEL3 from './assets/Wellbeing_SEL_3.jpg';

const API_BASE = (() => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'https://permataharapansecondary.sch.id/api';
  }
  return `${protocol}//${hostname}/api`;
})();

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

const extractYouTubeId = (url) => {
  if (!url || typeof url !== 'string') return null;
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/i);
  return match ? match[1] : null;
};

const isVideoUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  const clean = url.split('?')[0].toLowerCase();
  return (
    clean.endsWith('.mp4') ||
    clean.endsWith('.webm') ||
    clean.endsWith('.ogg') ||
    clean.endsWith('.mov') ||
    url.includes('youtube.com') ||
    url.includes('youtu.be') ||
    url.includes('/videos/')
  );
};

const resolveMediaUrl = (mediaId, directUrl, mediaMap = {}) => {
  if (mediaId && mediaMap && (mediaMap[mediaId] || mediaMap[String(mediaId)])) {
    return mediaMap[mediaId] || mediaMap[String(mediaId)];
  }
  const candidate = directUrl || (typeof mediaId === 'string' && isNaN(Number(mediaId)) ? mediaId : null);
  if (candidate && typeof candidate === 'string') {
    if (candidate.startsWith('http://') || candidate.startsWith('https://') || candidate.startsWith('blob:') || candidate.startsWith('data:')) {
      return candidate;
    }
    if (candidate.startsWith('/')) {
      const path = (candidate.startsWith('/api/') || candidate === '/api') ? candidate : `/api${candidate}`;
      return `${API_ORIGIN}${path}`;
    }
    if (candidate.includes('/uploads/')) {
      return `${API_ORIGIN}/api/${candidate.replace(/^\/+/, '')}`;
    }
    return `${API_ORIGIN}/api/uploads/studentlife/${candidate.replace(/^\/+/, '')}`;
  }
  return '';
};



const getPillarIcon = (pillar = '') => {
  const p = (typeof pillar === 'string' ? pillar : (pillar?.name || pillar?.title || '')).toString().toLowerCase();
  if (p.includes('aware')) return 'fa-brain';
  if (p.includes('regulat')) return 'fa-heart-pulse';
  if (p.includes('empath') || p.includes('kind')) return 'fa-hand-holding-heart';
  if (p.includes('goal')) return 'fa-bullseye';
  if (p.includes('relation')) return 'fa-user-group';
  return 'fa-star';
};

const getSupportIcon = (support = {}) => {
  if (support.icon) {
    return support.icon.startsWith('fa-') ? support.icon : `fa-${support.icon}`;
  }
  const t = (support.title || '').toLowerCase();
  if (t.includes('counsel')) return 'fa-user-tie';
  if (t.includes('advis') || t.includes('circle')) return 'fa-users';
  if (t.includes('academ') || t.includes('coach')) return 'fa-book';
  if (t.includes('famil') || t.includes('home')) return 'fa-house';
  if (t.includes('peer') || t.includes('mentor')) return 'fa-handshake';
  return 'fa-hands-holding-child';
};

const getTreeMetaphorMeta = (zoneKey) => {
  switch (zoneKey) {
    case 'easternCulture':
      return {
        level: 'LEVEL 01 • THE ROOTS (FOUNDATION)',
        metaphorName: 'The Roots',
        badgeColor: '#16a34a',
        icon: 'fa-leaf',
        summary: 'Eastern Culture values anchor character in respect, filial piety, humility, and moral integrity.'
      };
    case 'sel':
      return {
        level: 'LEVEL 02 • THE TRUNK (GROWTH STRUCTURE)',
        metaphorName: 'The Trunk',
        badgeColor: '#9333ea',
        icon: 'fa-brain',
        summary: 'Social Emotional Learning provides the sturdy trunk of self-regulation, empathy, and responsible decision-making.'
      };
    case 'wellbeing':
      return {
        level: 'LEVEL 03 • THE FRUITS (FLOURISHING OUTCOME)',
        metaphorName: 'The Fruits',
        badgeColor: '#eab308',
        icon: 'fa-apple-whole',
        summary: 'Wellbeing is the flourishing fruit: physical vitality, social harmony, and emotional flourishing.'
      };
    default:
      return {
        level: 'CORE FRAMEWORK',
        metaphorName: 'Character Foundation',
        badgeColor: '#d9bf79',
        icon: 'fa-seedling',
        summary: 'Holistic student character development.'
      };
  }
};

const getHouseTheme = (house = {}) => {
  const name = (house.name || '').toLowerCase();
  if (name.includes('courage')) {
    return {
      color: '#dc2626',
      bg: 'linear-gradient(180deg, #2d090d 0%, #170406 100%)',
      border: 'rgba(220, 38, 38, 0.45)',
      glow: 'rgba(220, 38, 38, 0.28)',
      badgeBg: 'rgba(220, 38, 38, 0.18)',
      icon: 'fa-shield-halved',
      accentColor: '#fca5a5'
    };
  }
  if (name.includes('love')) {
    return {
      color: '#ec4899',
      bg: 'linear-gradient(180deg, #2c081a 0%, #16030c 100%)',
      border: 'rgba(236, 72, 153, 0.45)',
      glow: 'rgba(236, 72, 153, 0.28)',
      badgeBg: 'rgba(236, 72, 153, 0.18)',
      icon: 'fa-heart',
      accentColor: '#f9a8d4'
    };
  }
  if (name.includes('hope')) {
    return {
      color: '#eab308',
      bg: 'linear-gradient(180deg, #2b1d04 0%, #140d01 100%)',
      border: 'rgba(234, 179, 8, 0.5)',
      glow: 'rgba(234, 179, 8, 0.28)',
      badgeBg: 'rgba(234, 179, 8, 0.18)',
      icon: 'fa-lightbulb',
      accentColor: '#fde047'
    };
  }
  if (name.includes('faith')) {
    return {
      color: '#f97316',
      bg: 'linear-gradient(180deg, #2e1204 0%, #150801 100%)',
      border: 'rgba(249, 115, 22, 0.45)',
      glow: 'rgba(249, 115, 22, 0.28)',
      badgeBg: 'rgba(249, 115, 22, 0.18)',
      icon: 'fa-cross',
      accentColor: '#fdba74'
    };
  }
  if (name.includes('peace')) {
    return {
      color: '#22c55e',
      bg: 'linear-gradient(180deg, #072513 0%, #031309 100%)',
      border: 'rgba(34, 197, 94, 0.45)',
      glow: 'rgba(34, 197, 94, 0.28)',
      badgeBg: 'rgba(34, 197, 94, 0.18)',
      icon: 'fa-dove',
      accentColor: '#86efac'
    };
  }
  const fallbackColor = house.color || '#d9bf79';
  return {
    color: fallbackColor,
    bg: 'linear-gradient(180deg, #240e44 0%, #15082a 100%)',
    border: 'rgba(217, 191, 121, 0.45)',
    glow: 'rgba(217, 191, 121, 0.28)',
    badgeBg: 'rgba(217, 191, 121, 0.18)',
    icon: 'fa-award',
    accentColor: '#f3e2b2'
  };
};

const getEventMeta = (eventOrTitle = '') => {
  let titleStr = '';
  let subStr = '';
  let customCat = '';
  if (typeof eventOrTitle === 'object' && eventOrTitle !== null) {
    titleStr = (eventOrTitle.title || eventOrTitle.name || '').toString().toLowerCase();
    subStr = (eventOrTitle.subtitle || eventOrTitle.date || '').toString().toLowerCase();
    customCat = (eventOrTitle.category || eventOrTitle.cat || '').toString().trim();
  } else {
    titleStr = (eventOrTitle || '').toString().toLowerCase();
  }

  const combined = `${titleStr} ${subStr}`;
  let icon = 'fa-calendar-alt';
  let category = customCat || 'Signature Annual Event';

  if (combined.includes('spartan') || combined.includes('cup') || combined.includes('sport') || combined.includes('olimpiade') || combined.includes('olympiad') || combined.includes('athletic')) {
    icon = 'fa-trophy';
    if (!customCat) category = 'Annual School Championship';
  } else if (combined.includes('entrepreneur') || combined.includes('business') || combined.includes('enterprise') || combined.includes('market') || combined.includes('bazaar')) {
    icon = 'fa-chart-line';
    if (!customCat) category = 'Enterprise & Financial Literacy';
  } else if (combined.includes('stem') || combined.includes('coding') || combined.includes('innovat') || combined.includes('science') || combined.includes('robot') || combined.includes('tech')) {
    icon = 'fa-atom';
    if (!customCat) category = 'STEM & Scientific Discovery';
  } else if (combined.includes('music') || combined.includes('art') || combined.includes('drama') || combined.includes('theatre') || combined.includes('dance') || combined.includes('concert') || combined.includes('show')) {
    icon = 'fa-palette';
    if (!customCat) category = 'Arts & Cultural Showcase';
  } else if (combined.includes('leader') || combined.includes('camp') || combined.includes('community')) {
    icon = 'fa-users';
    if (!customCat) category = 'Leadership & Community';
  }

  return { icon, category };
};

const getClubMeta = (clubOrTitle = '') => {
  let titleStr = '';
  let subStr = '';
  let customCat = '';
  if (typeof clubOrTitle === 'object' && clubOrTitle !== null) {
    titleStr = (clubOrTitle.title || clubOrTitle.name || '').toString().toLowerCase();
    subStr = (clubOrTitle.subtitle || '').toString().toLowerCase();
    customCat = (clubOrTitle.category || clubOrTitle.cat || '').toString().trim();
  } else {
    titleStr = (clubOrTitle || '').toString().toLowerCase();
  }

  if (customCat && customCat !== 'null' && customCat !== 'undefined') {
    const cLow = customCat.toLowerCase();
    let icon = 'fa-star';
    if (cLow.includes('sport') || cLow.includes('athletic') || cLow.includes('fitness')) icon = 'fa-medal';
    else if (cLow.includes('art') || cLow.includes('music') || cLow.includes('dance') || cLow.includes('perform')) icon = 'fa-palette';
    else if (cLow.includes('leader') || cLow.includes('service') || cLow.includes('communit')) icon = 'fa-crown';
    else if (cLow.includes('language') || cLow.includes('cultur')) icon = 'fa-globe';
    else if (cLow.includes('stem') || cLow.includes('science') || cLow.includes('robot') || cLow.includes('tech') || cLow.includes('code')) icon = 'fa-atom';
    return { icon, category: customCat };
  }

  const combined = `${titleStr} ${subStr}`;
  if (combined.includes('sport') || combined.includes('athletic') || combined.includes('futsal') || combined.includes('basket') || combined.includes('badminton') || combined.includes('swim') || combined.includes('soccer') || combined.includes('tennis')) {
    return { icon: 'fa-medal', category: 'Athletics & Fitness' };
  }
  if (combined.includes('art') || combined.includes('music') || combined.includes('performance') || combined.includes('dance') || combined.includes('danc') || combined.includes('choir') || combined.includes('theater') || combined.includes('drama') || combined.includes('band')) {
    return { icon: 'fa-palette', category: 'Creative Arts & Music' };
  }
  if (combined.includes('leader') || combined.includes('service') || combined.includes('community') || combined.includes('council') || combined.includes('volunteer')) {
    return { icon: 'fa-crown', category: 'Leadership & Service' };
  }
  if (combined.includes('language') || combined.includes('cultur') || combined.includes('english') || combined.includes('mandarin') || combined.includes('debate')) {
    return { icon: 'fa-globe', category: 'Language & Culture' };
  }
  if (combined.includes('stem') || combined.includes('robot') || combined.includes('code') || combined.includes('coding') || combined.includes('science')) {
    return { icon: 'fa-atom', category: 'STEM & Innovation' };
  }
  return { icon: 'fa-star', category: 'Extracurricular Club' };
};


const defaultHeroSlides = [heroSlide1, heroSlide2, heroSlide3];

const defaultClubs = [
  {
    title: 'Sports & Athletics Club',
    subtitle: 'Teamwork, discipline, and healthy competition',
    description:
      'Students build confidence through structured training sessions, friendly matches, and seasonal tournaments. Activities include futsal, basketball, badminton, and athletics conditioning tailored to each level.',
    highlights: ['Weekly training sessions', 'Interschool friendly matches', 'Fitness and agility drills'],
    images: [clubECASport, clubECASport2],
  },
  {
    title: 'Arts, Music, and Performance',
    subtitle: 'Creativity on stage and beyond',
    description:
      'From choir to contemporary dance, students explore creative expression with guidance from professional coaches. Showcases, exhibitions, and recitals help students share their talents with the community.',
    highlights: ['Choir and ensemble practice', 'Dance and theater workshops', 'Seasonal showcases'],
    images: [clubECAArt, clubECAArt2],
  },
  {
    title: 'Leadership & Community Service',
    subtitle: 'Grow character through impact',
    description:
      'Student leaders plan campus initiatives, service programs, and charity drives. Activities are designed to build empathy, communication skills, and a spirit of collaboration.',
    highlights: ['Student council programs', 'Community outreach', 'Leadership retreats'],
    images: [clubECALeadership, clubECALeadership2],
  },
  {
    title: 'Language and Cultural Club',
    subtitle: 'Celebrate global perspectives',
    description:
      'Language immersion sessions, cultural days, and exchange projects build confidence and appreciation for diversity. Students practice real-world communication through themed activities.',
    highlights: ['Cultural exchange days', 'Language immersion sessions', 'International celebration week'],
    images: [clubECALanguage, clubECALanguage2],
  },
];

const defaultEvents = [
  {
    title: 'SPARTAN CUPS',
    subtitle: 'Annual sports, arts, and leadership competitions',
    description:
      'Spartan Cups brings together students across levels for a full week of friendly competition, teamwork, and school pride. The program includes house teams, skill clinics, and a final celebration night with awards.',
    highlights: ['House leagues and leadership roles', 'Skill clinics led by coaches', 'Championship night and awards'],
    schedule: [
      'Week 1: Team drafting and leadership workshop',
      'Week 2: Qualifiers and sports clinics',
      'Week 3: Creative showcase + finals',
    ],
    images: [eventSpartan1, eventSpartan2],
  },
  {
    title: 'Entrepreneurship Program',
    subtitle: 'Ideas to impact: student-led enterprise journey',
    description:
      'Students learn how to build a business idea, pitch with confidence, and manage a mini enterprise. The program blends mentorship, budgeting, and storytelling so students gain real-world financial literacy and teamwork skills.',
    highlights: ['Mentor-led ideation labs', 'Market day with student booths', 'Pitching and storytelling training'],
    schedule: [
      'Phase 1: Idea sprint + customer interviews',
      'Phase 2: Budgeting and product testing',
      'Phase 3: Market day + final pitch',
    ],
    images: [eventEntrepreneur1, eventEntrepreneur2],
  },
  {
    title: 'Innovation, Coding, and Scientific Discovery',
    subtitle: 'STEM Program',
    description:
      'From coding challenges to science fairs, the STEM program encourages experimentation and collaboration. Students work on real problems, build prototypes, and present solutions at the annual Innovation Expo.',
    highlights: ['Robotics and coding labs', 'Science fair exhibition', 'Innovation Expo and demos'],
    schedule: [
      'Cycle 1: Design thinking and research',
      'Cycle 2: Build, test, and iterate',
      'Cycle 3: Expo prep and showcases',
    ],
    images: [eventInnovation1],
  },
];

const defaultHouses = [
  { name: 'House of Courage', motto: 'Courage Unlocks Dreams', color: '#dc2626', image: houseSystemCourage },
  { name: 'House of Love', motto: 'Love Guides Us Forward', color: '#ec4899', image: houseSystemLove },
  { name: 'House of Hope', motto: 'Hope Lights the Way', color: '#eab308', image: houseSystemHope },
  { name: 'House of Faith', motto: 'Faith Guides Our Path', color: '#f97316', image: houseSystemFaith },
  { name: 'House of Peace', motto: 'Peace Leads Us Forward', color: '#22c55e', image: houseSystemPeace },
];

const defaultTreeZoneContent = {
  wellbeing: {
    title: 'Holistic Wellbeing',
    subtitle: 'Nurturing physical vitality, social harmony, and emotional resilience (The Fruits)',
    content: [
      {
        heading: 'Physical Wellbeing',
        points: [
          'Cognitive stamina and sustained academic focus',
          'Emotional regulation & psychomotor alertness',
          'Active physical vitality and healthy motor habits',
          'Stress management and endurance through athletics'
        ]
      },
      {
        heading: 'Social Wellbeing',
        points: [
          'Empathetic active listening and peer support',
          'Constructive conflict resolution and mutual respect',
          'Inclusive campus culture celebrating diverse backgrounds',
          'Responsible and active community engagement'
        ]
      },
      {
        heading: 'Emotional Wellbeing',
        points: [
          'Metacognitive self-awareness and positive self-talk',
          'Adaptive coping mechanisms for academic pressures',
          'Balanced optimism and emotional composure'
        ]
      }
    ]
  },
  sel: {
    title: 'Social Emotional Learning (SEL)',
    subtitle: 'Essential soft skills and interpersonal competencies anchoring student growth (The Trunk)',
    content: [
      {
        heading: 'Self-Awareness',
        points: [
          'Recognizing personal emotions, values, and thought patterns',
          'Understanding how inner feelings guide behavior',
          'Cultivating a well-grounded growth mindset and confidence'
        ]
      },
      {
        heading: 'Self-Management',
        points: [
          'Regulating stress and impulse control effectively',
          'Sustaining motivation toward academic and personal milestones',
          'Personal accountability and proactive goal setting'
        ]
      },
      {
        heading: 'Social Awareness',
        points: [
          'Empathizing with perspectives of diverse communities',
          'Deciphering social cues and situational context with tact',
          'Demonstrating compassion, kindness, and civic respect'
        ]
      },
      {
        heading: 'Relationship Skills',
        points: [
          'Establishing and nurturing positive interpersonal bonds',
          'Communicating clearly and listening attentively',
          'Resisting negative peer pressure and anti-bullying leadership'
        ]
      },
      {
        heading: 'Responsible Decision-Making',
        points: [
          'Making ethical choices based on safety and respect',
          'Evaluating realistic consequences of personal actions',
          'Promoting holistic wellbeing of oneself and others'
        ]
      }
    ]
  },
  easternCulture: {
    title: 'Eastern Culture Values',
    subtitle: 'Foundational moral bedrock, filial respect, and noble virtues (The Roots)',
    content: [
      {
        heading: 'Grace & Courtesy (Respect)',
        points: [
          'Respect for elders, teachers, and mentorship traditions',
          'Honoring institutional order and communal harmony',
          'Stewardship and reverence for the natural environment',
          'Preserving cultural heritage and wisdom traditions'
        ]
      },
      {
        heading: 'Harmony & Balance',
        points: [
          'Kindness, empathy, and social coherence in daily life',
          'Mutual cooperation and communal solidarity (Gotong Royong)',
          'Filial piety and profound devotion to family and community'
        ]
      },
      {
        heading: 'Self-Discipline',
        points: [
          'Commitment to personal orderliness and punctuality',
          'Self-restraint, emotional mastery, and principled conduct',
          'Perseverance, resilience, and unyielding grit'
        ]
      },
      {
        heading: 'Spiritual & Moral Foundation',
        points: [
          'Devout faith, spirituality, and inner integrity',
          'Uncompromising honesty and ethical transparency',
          'Humility, modesty, and respectful demeanor',
          'Mindful reflection and purposeful living'
        ]
      }
    ]
  }
};

function StudentLifePage({ page, onNavigate }) {
  const [liveSections, setLiveSections] = useState(null);
  const [mediaMap, setMediaMap] = useState(() => {
    try {
      const cached = sessionStorage.getItem('cms_media_studentlife');
      return cached ? JSON.parse(cached) : {};
    } catch (e) {
      return {};
    }
  });

  // Fetch published sections and media directly from database API
  useEffect(() => {
    let isMounted = true;
    const loadPublishedData = async () => {
      try {
        const [secRes, mediaRes] = await Promise.allSettled([
          fetch(`${API_BASE}/studentlife/cms/sections?published=true&_t=${Date.now()}`, { credentials: 'omit' }),
          fetch(`${API_BASE}/studentlife/cms/media`, { credentials: 'omit' })
        ]);

        const map = {};
        if (mediaRes.status === 'fulfilled' && mediaRes.value?.ok) {
          try {
            const json = await mediaRes.value.json();
            const items = Array.isArray(json.data) ? json.data : [];
            items.forEach(m => {
              const id = m.id || m.media_id;
              const url = m.url || m.file_path;
              if (id && url) {
                map[id] = url;
                map[String(id)] = url;
              }
            });
          } catch (_) {}
        }

        if (isMounted && Object.keys(map).length > 0) {
          setMediaMap(prev => ({ ...prev, ...map }));
          try { sessionStorage.setItem('cms_media_studentlife', JSON.stringify(map)); } catch (_) {}
        }

        if (secRes.status === 'fulfilled' && secRes.value?.ok) {
          const json = await secRes.value.json();
          const sections = Array.isArray(json.data) ? json.data : Object.values(json.data || {});
          if (sections.length > 0 && isMounted) {
            const sectionMap = {};
            sections.forEach(s => {
              const cp = (s.content_published && s.content_published !== '{}' && s.content_published !== '[]')
                ? s.content_published
                : (s.content || s.content_published);
              let parsed = cp;
              if (typeof cp === 'string') {
                try { parsed = JSON.parse(cp); } catch (e) {}
              }
              const contentEn = parsed?.en || parsed || {};
              sectionMap[s.section_type] = contentEn;
            });
            setLiveSections(sectionMap);
          }
        }
      } catch (err) {
        console.warn('[StudentLifePage] Live data load error:', err);
      }
    };

    loadPublishedData();
    return () => { isMounted = false; };
  }, []);

  const resolveMedia = (idOrPath, fallback) => {
    if (!idOrPath) return fallback;
    const resolved = resolveMediaUrl(idOrPath, idOrPath, mediaMap);
    return resolved || fallback;
  };

  // Resolve 7 sections strictly from published database content
  const heroSec = liveSections?.['student-life-hero'] || page?.raw_sections?.['student-life-hero'] || page?.sections?.['student-life-hero'] || page?.hero || {};
  const clubsSec = liveSections?.['student-life-clubs'] || page?.raw_sections?.['student-life-clubs'] || page?.sections?.['student-life-clubs'] || {};
  const eventsSec = liveSections?.['student-life-events'] || page?.raw_sections?.['student-life-events'] || page?.sections?.['student-life-events'] || {};
  const houseSec = liveSections?.['student-life-house-system'] || page?.raw_sections?.['student-life-house-system'] || page?.sections?.['student-life-house-system'] || page?.houseSystem || {};
  const wellbeingSec = liveSections?.['student-life-wellbeing'] || page?.raw_sections?.['student-life-wellbeing'] || page?.sections?.['student-life-wellbeing'] || page?.wellbeing || {};
  const characterShapingSec = liveSections?.['student-life-character-shaping'] || page?.raw_sections?.['student-life-character-shaping'] || page?.sections?.['student-life-character-shaping'] || page?.characterShaping || {};
  const leapsSec = liveSections?.['student-life-leaps'] || page?.raw_sections?.['student-life-leaps'] || page?.sections?.['student-life-leaps'] || page?.leaps || {};

  // Hero Section Data - Exact Match to About Us Hero Structure
  const heroKicker = (heroSec.kicker && heroSec.kicker !== 'null' && heroSec.kicker !== 'undefined') ? heroSec.kicker : 'Student Life';
  const heroTitle = (heroSec.title && heroSec.title !== 'null' && heroSec.title !== 'undefined') ? heroSec.title : (page?.hero_title || page?.title || 'Student Life');
  const heroSummary =
    (heroSec.summary && heroSec.summary !== 'null' && heroSec.summary !== 'undefined') ? heroSec.summary :
    (heroSec.subtitle && heroSec.subtitle !== 'null' && heroSec.subtitle !== 'undefined') ? heroSec.subtitle :
    (page?.hero_summary && page?.hero_summary !== 'null') ? page?.hero_summary :
    (page?.summary && page?.summary !== 'null') ? page?.summary :
    'A vibrant campus rhythm filled with clubs, leadership, arts, sports, and community experiences.';

  const rawSlides = useMemo(() => {
    if (Array.isArray(heroSec?.slides) && heroSec.slides.length > 0) return heroSec.slides;
    if (Array.isArray(page?.hero?.slides) && page.hero.slides.length > 0) return page.hero.slides;
    if (Array.isArray(page?.slides) && page.slides.length > 0) return page.slides;
    return [];
  }, [heroSec?.slides, page?.hero?.slides, page?.slides]);

  const heroSlides = useMemo(() => {
    const list = rawSlides.map((slide, idx) => {
      const rawUrl = typeof slide === 'object' && slide !== null
        ? (slide.image || slide.url || slide.file_path || slide.video || '')
        : (typeof slide === 'string' ? slide : '');
      const resolved = resolveMediaUrl(rawUrl, rawUrl, mediaMap) || rawUrl;
      const videoCandidate = (typeof slide === 'object' && slide !== null && slide.video)
        ? resolveMediaUrl(slide.video, slide.video, mediaMap)
        : (isVideoUrl(resolved) ? resolved : null);
      const isVideo = Boolean(videoCandidate);
      const youtubeId = isVideo ? extractYouTubeId(videoCandidate) : null;
      return {
        id: (typeof slide === 'object' && slide?.order) ? slide.order : idx,
        url: videoCandidate || resolved,
        isVideo,
        isYouTube: Boolean(youtubeId),
        youtubeId
      };
    }).filter(s => Boolean(s.url));

    const singleVideo = heroSec.video || heroSec.video_url || heroSec.video_file || page?.hero_video;
    if (list.length === 0 && singleVideo) {
      const resolvedVid = resolveMediaUrl(singleVideo, singleVideo, mediaMap);
      const ytId = extractYouTubeId(resolvedVid);
      list.push({
        id: 'hero-vid-0',
        url: resolvedVid,
        isVideo: true,
        isYouTube: Boolean(ytId),
        youtubeId: ytId
      });
    }

    return list.length > 0 ? list : defaultHeroSlides.map((img, idx) => ({
      id: idx,
      url: img,
      isVideo: false,
      isYouTube: false,
      youtubeId: null
    }));
  }, [rawSlides, heroSec, page?.hero_video, mediaMap]);

  const [activeHero, setActiveHero] = useState(0);
  const [activeWellbeingSlide, setActiveWellbeingSlide] = useState(0);
  const [activeWellbeingCard, setActiveWellbeingCard] = useState(0);
  const [activeTreeZone, setActiveTreeZone] = useState('easternCulture');
  const [showTreeModal, setShowTreeModal] = useState(false);
  const [flippedLeapsCard, setFlippedLeapsCard] = useState(null);
  const modalBodyRef = useRef(null);

  const openTreeModal = (zoneKey) => {
    setActiveTreeZone(zoneKey);
    setShowTreeModal(true);
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = 0;
    }
  };

  const handleSelectModalTab = (zoneKey) => {
    setActiveTreeZone(zoneKey);
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = 0;
    }
  };

  useEffect(() => {
    if (showTreeModal) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
          setShowTreeModal(false);
        }
      };
      window.addEventListener('keydown', handleKeyDown);

      return () => {
        document.body.style.overflow = originalOverflow;
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [showTreeModal]);

  useEffect(() => {
    if (heroSlides.length <= 1) return;
    const intervalId = setInterval(() => {
      setActiveHero((current) => (current + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(intervalId);
  }, [heroSlides.length]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveWellbeingSlide((current) => (current + 1) % 3);
    }, 5000);
    return () => clearInterval(intervalId);
  }, []);

  const clubsKicker = (clubsSec?.kicker && clubsSec.kicker !== 'null' && clubsSec.kicker !== 'undefined') ? clubsSec.kicker : 'Clubs & ECA';
  const clubsTitle = (clubsSec?.title && clubsSec.title !== 'null' && clubsSec.title !== 'undefined') ? clubsSec.title : 'Explore activities that build confidence, creativity, and friendship';
  const clubsDesc = (clubsSec?.description && clubsSec.description !== 'null' && clubsSec.description !== 'undefined') ? clubsSec.description : 'Our clubs and extracurricular activities are designed to help students discover passions, practice leadership, and build lasting skills beyond the classroom. Each club features recurring sessions, guided mentorship, and student-led showcases.';

  const clubs = useMemo(() => {
    const dbClubs = clubsSec?.clubs || page?.clubs || page?.sections?.['student-life-clubs']?.clubs;
    if (Array.isArray(dbClubs) && dbClubs.length > 0) {
      return dbClubs.map((club, idx) => {
        const defaultItem = defaultClubs[idx % defaultClubs.length] || defaultClubs[0];
        let rawImgs = [];
        if (Array.isArray(club.images) && club.images.length > 0) {
          rawImgs = club.images;
        } else if (club.image) {
          rawImgs = [club.image];
        }
        const resolvedImages = rawImgs.length > 0
          ? rawImgs.map((img, i) => resolveMedia(img, defaultItem.images[i % defaultItem.images.length]))
          : defaultItem.images;
        return {
          title: (club.title && club.title !== 'null') ? club.title : defaultItem.title,
          subtitle: (club.subtitle && club.subtitle !== 'null') ? club.subtitle : defaultItem.subtitle,
          category: (club.category && club.category !== 'null') ? club.category : '',
          description: (club.description && club.description !== 'null') ? club.description : defaultItem.description,
          highlights: Array.isArray(club.highlights) && club.highlights.length > 0 ? club.highlights.filter(h => h && h !== 'null') : defaultItem.highlights,
          images: resolvedImages
        };
      });
    }
    return defaultClubs;
  }, [clubsSec, page?.clubs, mediaMap]);

  const [activeClubSlides, setActiveClubSlides] = useState(clubs.map(() => 0));

  const prevClubSlide = (clubIndex, totalImages) => {
    if (!totalImages || totalImages <= 1) return;
    setActiveClubSlides((current) =>
      current.map((val, idx) => (idx === clubIndex ? (val - 1 + totalImages) % totalImages : val))
    );
  };

  const nextClubSlide = (clubIndex, totalImages) => {
    if (!totalImages || totalImages <= 1) return;
    setActiveClubSlides((current) =>
      current.map((val, idx) => (idx === clubIndex ? (val + 1) % totalImages : val))
    );
  };


  const events = useMemo(() => {
    const dbEvents = eventsSec?.events || page?.events || page?.sections?.['student-life-events']?.events;
    if (Array.isArray(dbEvents) && dbEvents.length > 0) {
      return dbEvents.map((ev, idx) => {
        const defaultItem = defaultEvents[idx % defaultEvents.length] || defaultEvents[0];
        let rawImgs = [];
        if (Array.isArray(ev.images) && ev.images.length > 0) {
          rawImgs = ev.images;
        } else if (ev.image) {
          rawImgs = [ev.image];
        }
        const resolvedImages = rawImgs.length > 0
          ? rawImgs.map((img, i) => resolveMedia(img, defaultItem.images[i % defaultItem.images.length]))
          : defaultItem.images;
        return {
          title: ev.title || defaultItem.title,
          subtitle: ev.subtitle || ev.date || defaultItem.subtitle,
          category: ev.category || '',
          date: ev.date || '',
          description: ev.description || defaultItem.description,
          highlights: Array.isArray(ev.highlights) && ev.highlights.length > 0 ? ev.highlights : defaultItem.highlights,
          schedule: Array.isArray(ev.schedule) && ev.schedule.length > 0 ? ev.schedule : defaultItem.schedule,
          images: resolvedImages
        };
      });
    }
    return defaultEvents;
  }, [eventsSec, page?.events, mediaMap]);

  const houseSystem = useMemo(() => {
    const dbHouses = houseSec?.houses || page?.houses;
    const mappedHouses = (Array.isArray(dbHouses) && dbHouses.length > 0)
      ? dbHouses.map((h, idx) => {
          const defaultH = defaultHouses.find(dh => dh.name.toLowerCase() === h.name?.toLowerCase()) || defaultHouses[idx % defaultHouses.length] || defaultHouses[0];
          return {
            ...h,
            name: h.name || defaultH.name,
            motto: h.motto || defaultH.motto,
            color: h.color || defaultH.color,
            image: resolveMedia(h.image, defaultH.image),
          };
        })
      : defaultHouses;

    return {
      kicker: houseSec?.kicker || 'House System',
      title: houseSec?.title || 'House System',
      subtitle: houseSec?.subtitle || 'Belonging, leadership, and school pride',
      description: houseSec?.description || 'Our House System groups students across grades into supportive teams that build unity, responsibility, and healthy competition. Each house earns points through academics, service, and events, encouraging students to lead with character.',
      houses: mappedHouses,
      image: mappedHouses[0]?.image || houseSystemCourage,
      imageLabel: 'House Gallery',
      imageCaption: 'Space for a featured house photo or house activity moment.'
    };
  }, [houseSec, page?.houses, mediaMap]);

  const wellbeing = useMemo(() => {
    const defaultImages = [wellbeingSEL1, wellbeingSEL2, wellbeingSEL3];
    const resolvedImages = Array.isArray(wellbeingSec?.images) && wellbeingSec.images.length > 0
      ? wellbeingSec.images.map((img, i) => resolveMedia(img, defaultImages[i % defaultImages.length]))
      : defaultImages;

    return {
      kicker: wellbeingSec?.kicker || 'Student Care',
      title: wellbeingSec?.title || 'Wellbeing & Social Emotional Learning',
      subtitle: wellbeingSec?.subtitle || 'Support for emotional and academic growth',
      description: wellbeingSec?.description || 'Our SEL framework helps students build resilience, confidence, and healthy relationships while supporting academic success. Dedicated counselors, advisory teachers, and structured lessons ensure every student feels seen and supported.',
      pillars: Array.isArray(wellbeingSec?.pillars) && wellbeingSec.pillars.length > 0 ? wellbeingSec.pillars : ['Self-awareness', 'Emotional regulation', 'Empathy & kindness', 'Goal setting', 'Positive relationships'],
      supports: Array.isArray(wellbeingSec?.supports) && wellbeingSec.supports.length > 0 ? wellbeingSec.supports : [
        { title: 'Counselor Check-ins', detail: 'Regular sessions for guidance, emotional support, and personal goal planning.', icon: 'fa-user-tie' },
        { title: 'Advisory Circles', detail: 'Weekly small-group conversations that build trust and communication skills.', icon: 'fa-users' },
        { title: 'Academic Coaching', detail: 'Study strategies, time management, and learning support tailored to each student.', icon: 'fa-book' },
        { title: 'Family Partnership', detail: 'Parent updates, workshops, and shared action plans for wellbeing at home.', icon: 'fa-home' },
        { title: 'Peer Mentoring', detail: 'Older students support younger peers through buddy programs, fostering leadership and belonging.', icon: 'fa-handshake' },
      ],
      images: resolvedImages
    };
  }, [wellbeingSec, mediaMap]);

  const treeZoneContent = useMemo(() => {
    const dbZones = characterShapingSec?.zones || page?.characterShaping?.zones || page?.sections?.['student-life-character-shaping']?.zones;
    if (dbZones && typeof dbZones === 'object') {
      const res = {};
      ['wellbeing', 'sel', 'easternCulture'].forEach(zoneKey => {
        const z = dbZones[zoneKey];
        if (z) {
          res[zoneKey] = {
            title: z.title || defaultTreeZoneContent[zoneKey].title,
            subtitle: z.subtitle || defaultTreeZoneContent[zoneKey].subtitle,
            content: z.pillars || z.content || defaultTreeZoneContent[zoneKey].content
          };
        } else {
          res[zoneKey] = defaultTreeZoneContent[zoneKey];
        }
      });
      return res;
    }
    return defaultTreeZoneContent;
  }, [characterShapingSec, page]);

  useEffect(() => {
    setActiveClubSlides(clubs.map(() => 0));
  }, [clubs]);

  const [activeEventSlides, setActiveEventSlides] = useState(
    events.map(() => 0)
  );

  useEffect(() => {
    setActiveEventSlides(events.map(() => 0));
  }, [events]);

  const prevEventSlide = (eventIndex, totalImages) => {
    if (!totalImages || totalImages <= 1) return;
    setActiveEventSlides((current) =>
      current.map((val, idx) => (idx === eventIndex ? (val - 1 + totalImages) % totalImages : val))
    );
  };

  const nextEventSlide = (eventIndex, totalImages) => {
    if (!totalImages || totalImages <= 1) return;
    setActiveEventSlides((current) =>
      current.map((val, idx) => (idx === eventIndex ? (val + 1) % totalImages : val))
    );
  };

  const prevWellbeingSlide = (totalImages) => {
    if (!totalImages || totalImages <= 1) return;
    setActiveWellbeingSlide((current) => (current - 1 + totalImages) % totalImages);
  };

  const nextWellbeingSlide = (totalImages) => {
    if (!totalImages || totalImages <= 1) return;
    setActiveWellbeingSlide((current) => (current + 1) % totalImages);
  };



  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveClubSlides((current) =>
        current.map((value, index) => (value + 1) % clubs[index].images.length)
      );
    }, 4500);
    return () => clearInterval(intervalId);
  }, [clubs]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveEventSlides((current) =>
        current.map((value, index) => (value + 1) % events[index].images.length)
      );
    }, 4800);
    return () => clearInterval(intervalId);
  }, [events]);

  const leaps = useMemo(() => {
    const dbPrograms = leapsSec?.programs || page?.leaps?.programs || page?.sections?.['student-life-leaps']?.programs;
    const defaultLeapsList = [
      { letter: 'L', fullText: 'Leadership', description: 'Developing confident decision-makers who inspire and guide others with integrity, vision, and empathy.', icon: 'fa-crown', color: '#e11d48' },
      { letter: 'E', fullText: 'Extracurricular', description: 'Exploring passions through clubs, athletics, arts, and experiential learning beyond traditional classrooms.', icon: 'fa-star', color: '#d97706' },
      { letter: 'A', fullText: 'Achievement', description: 'Pursuing academic excellence and personal breakthroughs through discipline, intellectual curiosity, and grit.', icon: 'fa-trophy', color: '#059669' },
      { letter: 'P', fullText: 'Participation', description: 'Actively engaging in campus life, civic initiatives, and collaborative projects that forge lifelong camaraderie.', icon: 'fa-handshake', color: '#2563eb' },
      { letter: 'S', fullText: 'Service', description: 'Contributing meaningfully to community welfare, fostering global perspective, and demonstrating selfless care.', icon: 'fa-heart', color: '#7c3aed' },
    ];

    const items = (Array.isArray(dbPrograms) && dbPrograms.length > 0)
      ? dbPrograms.map((p, idx) => ({
          letter: p.letter || (p.title || '')[0]?.toUpperCase() || defaultLeapsList[idx % defaultLeapsList.length]?.letter || 'L',
          fullText: p.fullText || p.title || defaultLeapsList[idx % defaultLeapsList.length]?.fullText,
          description: p.description || defaultLeapsList[idx % defaultLeapsList.length]?.description,
          icon: p.icon ? (p.icon.startsWith('fa-') ? p.icon : `fa-${p.icon}`) : defaultLeapsList[idx % defaultLeapsList.length]?.icon,
          color: p.color || defaultLeapsList[idx % defaultLeapsList.length]?.color || '#4D96FF'
        }))
      : defaultLeapsList;

    return {
      kicker: leapsSec?.kicker && leapsSec.kicker !== 'null' && leapsSec.kicker !== 'undefined' ? leapsSec.kicker : 'Student Development',
      title: leapsSec?.title && leapsSec.title !== 'null' && leapsSec.title !== 'undefined' ? leapsSec.title : 'LEAPS Framework',
      description: leapsSec?.description && leapsSec.description !== 'null' && leapsSec.description !== 'undefined' ? leapsSec.description : 'Our holistic approach to student growth encompasses five key dimensions that shape well-rounded learners and responsible global citizens.',
      items
    };
  }, [leapsSec, page]);

  useEffect(() => {
    const animatedItems = document.querySelectorAll('.life-animate, .event-animate');
    if (!animatedItems.length) {
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    animatedItems.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="student-life-page">
      {/* Redesigned Hero Section - Matches About Us Hero Exactly */}
      <section className="student-life-hero" id="student-life-overview">
        <div className="student-life-hero-media" aria-hidden="true">
          {heroSlides.length > 0 ? (
            heroSlides.map((slide, index) => {
              const isCurrent = index === activeHero;
              return (
                <div
                  key={slide.id || index}
                  className={`student-life-hero-slide ${isCurrent ? 'active' : ''}`}
                >
                  {slide.isVideo ? (
                    slide.isYouTube ? (
                      <iframe
                        className="student-life-hero-video-frame"
                        src={`https://www.youtube.com/embed/${slide.youtubeId}?autoplay=1&mute=1&loop=1&playlist=${slide.youtubeId}&controls=0&playsinline=1&modestbranding=1&rel=0`}
                        title="Hero video background"
                        allow="autoplay; encrypted-media"
                        tabIndex="-1"
                      />
                    ) : (
                      <video
                        className="student-life-hero-video-element"
                        src={slide.url}
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="auto"
                      />
                    )
                  ) : (
                    <img
                      src={slide.url}
                      alt={heroTitle}
                      className="student-life-hero-img-element"
                    />
                  )}
                </div>
              );
            })
          ) : (
            <div className="student-life-hero-slide active student-life-hero-gradient-fallback" />
          )}
        </div>

        <div className="student-life-hero-overlay" aria-hidden="true" />

        <div className="student-life-hero-content-wrap">
          <div className="student-life-hero-content">
            <p className="student-life-hero-kicker">
              {heroKicker}
            </p>

            <h1 className="student-life-hero-title">
              {heroTitle}
            </h1>

            {heroSummary && (
              <p className="student-life-hero-summary">
                {heroSummary}
              </p>
            )}

            {heroSlides.length > 1 && (
              <div className="student-life-hero-dots" role="tablist" aria-label="Student life hero carousel navigation">
                {heroSlides.map((slide, index) => (
                  <button
                    key={slide.id || index}
                    type="button"
                    className={`student-life-hero-dot ${index === activeHero ? 'active' : ''}`}
                    onClick={() => setActiveHero(index)}
                    aria-label={`Slide ${index + 1}`}
                    role="tab"
                    aria-selected={index === activeHero}
                  >
                    <span className="student-life-hero-dot-bar" />
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="student-life-clubs" id="clubs-eca">
        <div className="student-life-clubs-header">
          <div className="student-life-clubs-kicker-wrap">
            <span className="student-life-clubs-kicker-badge">
              <span className="student-life-clubs-kicker-dot" />
              <span>{clubsKicker}</span>
            </span>
          </div>

          <h2 className="student-life-clubs-title">
            {clubsTitle}
          </h2>

          <p className="student-life-clubs-desc">
            {clubsDesc}
          </p>
        </div>

        <div className="student-life-clubs-grid">
          {clubs.map((club, index) => {
            const isReversed = index % 2 === 1;
            const meta = getClubMeta(club);
            const totalImages = Array.isArray(club.images) ? club.images.length : 0;
            const activeSlide = activeClubSlides[index] || 0;

            return (
              <article
                className={`student-life-club-card life-animate ${isReversed ? 'reversed' : ''}`}
                key={club.title || index}
              >
                {/* Top Multi-Tone Prestige Ribbon */}
                <div className="student-life-club-ribbon" />

                {/* Content Column */}
                <div className="student-life-club-content">
                  <div className="student-life-club-badge-row">
                    <span className="student-life-club-cat-badge">
                      <i className={`fas ${meta.icon}`} aria-hidden="true" />
                      <span>{meta.category}</span>
                    </span>
                    {club.subtitle && (
                      <span className="student-life-club-tagline">
                        {club.subtitle}
                      </span>
                    )}
                  </div>

                  <h3 className="student-life-club-name">{club.title}</h3>

                  <p className="student-life-club-description">{club.description}</p>

                  {Array.isArray(club.highlights) && club.highlights.length > 0 && (
                    <div className="student-life-club-highlights-box">
                      <span className="club-highlights-title">Key Highlights & Focus</span>
                      <ul className="club-highlights-list">
                        {club.highlights.map((item, hIdx) => {
                          const itemText = typeof item === 'string' ? item : (item?.text || item?.title || item?.name || JSON.stringify(item));
                          return (
                            <li key={hIdx}>
                              <span className="club-highlight-icon" aria-hidden="true">
                                <i className="fas fa-check" />
                              </span>
                              <span className="club-highlight-text">{itemText}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>

                {/* Media Carousel Column */}
                <div className="student-life-club-media" aria-label={`${club.title} photo gallery`}>
                  <div className="student-life-club-media-inner">
                    {club.images.map((image, imageIndex) => (
                      <div
                        key={`${club.title}-${imageIndex}`}
                        className={`student-life-club-slide ${
                          imageIndex === activeSlide ? 'active' : ''
                        }`}
                      >
                        <img
                          src={image}
                          alt={`${club.title} moment ${imageIndex + 1}`}
                          className="student-life-club-img"
                          onError={(e) => {
                            const fb = defaultClubs[index % defaultClubs.length]?.images[imageIndex % 2] || clubImage1;
                            if (e.currentTarget.src !== fb) {
                              e.currentTarget.src = fb;
                            }
                          }}
                        />
                      </div>
                    ))}

                    <div className="student-life-club-media-overlay" aria-hidden="true" />

                    {/* Counter Badge */}
                    {totalImages > 0 && (
                      <div className="student-life-club-media-counter">
                        <i className="fas fa-camera" aria-hidden="true" />
                        <span>{activeSlide + 1} / {totalImages}</span>
                      </div>
                    )}

                    {/* Left / Right Arrow Navigation */}
                    {totalImages > 1 && (
                      <>
                        <button
                          type="button"
                          className="club-nav-arrow club-nav-prev"
                          onClick={() => prevClubSlide(index, totalImages)}
                          aria-label={`Previous photo for ${club.title}`}
                        >
                          <i className="fas fa-chevron-left" />
                        </button>
                        <button
                          type="button"
                          className="club-nav-arrow club-nav-next"
                          onClick={() => nextClubSlide(index, totalImages)}
                          aria-label={`Next photo for ${club.title}`}
                        >
                          <i className="fas fa-chevron-right" />
                        </button>
                      </>
                    )}

                    {/* Dots Bar */}
                    {totalImages > 1 && (
                      <div className="student-life-club-dots" role="tablist" aria-label={`${club.title} slide controls`}>
                        {club.images.map((_, dotIdx) => (
                          <button
                            key={dotIdx}
                            type="button"
                            className={`student-life-club-dot ${dotIdx === activeSlide ? 'active' : ''}`}
                            onClick={() =>
                              setActiveClubSlides((current) =>
                                current.map((value, idx) => (idx === index ? dotIdx : value))
                              )
                            }
                            aria-label={`Show ${club.title} slide ${dotIdx + 1}`}
                            role="tab"
                            aria-selected={dotIdx === activeSlide}
                          >
                            <span className="club-dot-bar" />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>



      <section className="events-list" id="events-competitions">
        <div className="events-list-header">
          <div className="events-list-kicker-wrap">
            <span className="events-list-kicker-badge">
              <span className="events-list-kicker-dot" />
              <span>{eventsSec?.kicker && eventsSec.kicker !== 'null' && eventsSec.kicker !== 'undefined' ? eventsSec.kicker : 'Events & Competitions'}</span>
            </span>
          </div>

          <h2 className="events-list-title">
            {eventsSec?.title && eventsSec.title !== 'null' && eventsSec.title !== 'undefined' ? eventsSec.title : 'SPARTAN Cups, Entrepreneurship, and STEM Highlights'}
          </h2>

          <p className="events-list-desc">
            {eventsSec?.description && eventsSec.description !== 'null' && eventsSec.description !== 'undefined' ? eventsSec.description : 'Signature programs that build teamwork, innovation, and leadership. Each event includes mentoring, showcases, and hands-on activities that keep students engaged throughout the year.'}
          </p>
        </div>

        <div className="events-grid">
          {events.map((event, index) => {
            const isReversed = index % 2 === 1;
            const meta = getEventMeta(event);
            const totalImages = Array.isArray(event.images) ? event.images.length : 0;
            const activeSlide = activeEventSlides[index] || 0;

            return (
              <article
                className={`events-card event-animate ${isReversed ? 'reversed' : ''}`}
                key={event.title || index}
              >
                {/* Top Multi-Tone Prestige Gold Ribbon */}
                <div className="events-card-ribbon" />

                {/* Content Column */}
                <div className="events-card-content">
                  <div className="events-card-badge-row">
                    <span className="events-card-cat-badge">
                      <i className={`fas ${meta.icon}`} aria-hidden="true" />
                      <span>{meta.category}</span>
                    </span>
                    {event.subtitle && event.subtitle !== 'null' && event.subtitle !== 'undefined' && (
                      <span className="events-card-tagline">
                        {event.subtitle}
                      </span>
                    )}
                  </div>

                  <h3 className="events-card-title">{event.title}</h3>

                  {event.description && event.description !== 'null' && event.description !== 'undefined' && (
                    <p className="events-card-description">{event.description}</p>
                  )}

                  {/* Highlights Block */}
                  {Array.isArray(event.highlights) && event.highlights.length > 0 && (
                    <div className="events-card-highlights">
                      <span className="events-highlights-title">
                        <i className="fas fa-star" aria-hidden="true" />
                        Signature Highlights
                      </span>
                      <div className="events-chip-row">
                        {event.highlights.map((item, hIdx) => {
                          const chipText = typeof item === 'string'
                            ? item
                            : (item?.text || item?.title || item?.name || item?.label || '');
                          if (!chipText || chipText === 'null' || chipText === 'undefined') return null;
                          return (
                            <span className="events-highlight-chip" key={hIdx}>
                              <span className="events-chip-dot" />
                              <span>{chipText}</span>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Program Flow & Milestones Timeline */}
                  {Array.isArray(event.schedule) && event.schedule.length > 0 && (
                    <div className="events-card-timeline">
                      <span className="events-timeline-title">
                        <i className="fas fa-stream" aria-hidden="true" />
                        Program Flow & Milestones
                      </span>
                      <div className="events-timeline-steps">
                        {event.schedule.map((item, sIdx) => {
                          if (!item) return null;
                          let stepBadge = `Phase ${sIdx + 1}`;
                          let stepText = '';

                          if (typeof item === 'string') {
                            if (item.includes(':')) {
                              const parts = item.split(':');
                              stepBadge = parts[0]?.trim() || `Phase ${sIdx + 1}`;
                              stepText = parts.slice(1).join(':').trim();
                            } else {
                              stepBadge = `Phase ${sIdx + 1}`;
                              stepText = item.trim();
                            }
                          } else if (typeof item === 'object') {
                            stepBadge = item.phase || item.time || item.badge || item.step || item.title || `Phase ${sIdx + 1}`;
                            stepText = item.text || item.activity || item.description || item.detail || '';
                            if (!stepText && item.title && item.phase) {
                              stepText = item.title;
                            }
                          } else {
                            stepText = String(item);
                          }

                          if (!stepText || stepText === 'null' || stepText === 'undefined') return null;

                          return (
                            <div className="events-timeline-step" key={sIdx}>
                              <span className="events-step-badge">{stepBadge}</span>
                              <span className="events-step-text">{stepText}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>

                {/* Media Carousel Column */}
                <div className="events-card-media" aria-label={`${event.title} photo gallery`}>
                  <div className="events-card-media-inner">
                    {event.images.map((image, imageIndex) => (
                      <div
                        key={`${event.title}-${imageIndex}`}
                        className={`events-card-slide ${
                          imageIndex === activeSlide ? 'active' : ''
                        }`}
                      >
                        <img
                          src={image}
                          alt={`${event.title} moment ${imageIndex + 1}`}
                          className="events-card-img"
                          onError={(e) => {
                            const fb = defaultEvents[index % defaultEvents.length]?.images[imageIndex % 2] || eventSpartan1;
                            if (e.currentTarget.src !== fb) {
                              e.currentTarget.src = fb;
                            }
                          }}
                        />
                      </div>
                    ))}

                    <div className="events-card-media-overlay" aria-hidden="true" />

                    {/* Counter Badge */}
                    {totalImages > 0 && (
                      <div className="events-card-media-counter">
                        <i className="fas fa-camera" aria-hidden="true" />
                        <span>{activeSlide + 1} / {totalImages}</span>
                      </div>
                    )}

                    {/* Left / Right Arrow Navigation */}
                    {totalImages > 1 && (
                      <>
                        <button
                          type="button"
                          className="events-nav-arrow events-nav-prev"
                          onClick={() => prevEventSlide(index, totalImages)}
                          aria-label={`Previous photo for ${event.title}`}
                        >
                          <i className="fas fa-chevron-left" />
                        </button>
                        <button
                          type="button"
                          className="events-nav-arrow events-nav-next"
                          onClick={() => nextEventSlide(index, totalImages)}
                          aria-label={`Next photo for ${event.title}`}
                        >
                          <i className="fas fa-chevron-right" />
                        </button>
                      </>
                    )}

                    {/* Dots Bar */}
                    {totalImages > 1 && (
                      <div className="events-card-dots" role="tablist" aria-label={`${event.title} slide controls`}>
                        {event.images.map((_, dotIdx) => (
                          <button
                            key={dotIdx}
                            type="button"
                            className={`events-card-dot ${dotIdx === activeSlide ? 'active' : ''}`}
                            onClick={() =>
                              setActiveEventSlides((current) =>
                                current.map((value, idx) => (idx === index ? dotIdx : value))
                              )
                            }
                            aria-label={`Show ${event.title} slide ${dotIdx + 1}`}
                            role="tab"
                            aria-selected={dotIdx === activeSlide}
                          >
                            <span className="events-dot-bar" />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>



      <section className="house-system" id="house-system">
        <div className="house-system-header">
          <div className="house-system-kicker-wrap">
            <span className="house-system-kicker-badge">
              <span className="house-system-kicker-dot" />
              <span>{houseSystem.kicker && houseSystem.kicker !== 'null' && houseSystem.kicker !== 'undefined' ? houseSystem.kicker : 'House System'}</span>
            </span>
          </div>

          <h2 className="house-system-title">
            {houseSystem.title && houseSystem.title !== 'null' && houseSystem.title !== 'undefined' ? houseSystem.title : 'House System'}
          </h2>

          {houseSystem.subtitle && houseSystem.subtitle !== 'null' && houseSystem.subtitle !== 'undefined' && (
            <p className="house-system-subtitle">
              {houseSystem.subtitle}
            </p>
          )}

          <p className="house-system-desc">
            {houseSystem.description && houseSystem.description !== 'null' && houseSystem.description !== 'undefined' ? houseSystem.description : 'Our House System groups students across grades into supportive teams that build unity, responsibility, and healthy competition.'}
          </p>
        </div>

        <div className="house-system-grid">
          {houseSystem.houses.map((house, hIdx) => {
            const theme = getHouseTheme(house);
            const houseSlug = `house-${(house.name || '').toLowerCase().replace(/\s+/g, '-')}`;

            return (
              <article
                key={house.name || hIdx}
                className="house-system-card life-animate"
                style={{
                  background: theme.bg,
                  borderColor: theme.border,
                  boxShadow: `0 20px 48px -12px rgba(0, 0, 0, 0.5), 0 0 20px ${theme.glow}`
                }}
                onClick={() => onNavigate && onNavigate(houseSlug)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    onNavigate && onNavigate(houseSlug);
                  }
                }}
                aria-label={`Explore ${house.name}`}
              >
                {/* Top Multi-Tone Accent Ribbon in House Theme Color + Gold */}
                <div
                  className="house-card-ribbon"
                  style={{
                    background: `linear-gradient(90deg, ${theme.color} 0%, #f3e2b2 50%, ${theme.color} 100%)`
                  }}
                />

                {/* Uncropped House Crest / Artwork Container */}
                <div className="house-card-media-uncropped">
                  <img
                    src={house.image}
                    alt={`${house.name} emblem`}
                    className="house-card-uncropped-img"
                    onError={(e) => {
                      const fb = defaultHouses[hIdx % defaultHouses.length]?.image || houseSystemCourage;
                      if (e.currentTarget.src !== fb) {
                        e.currentTarget.src = fb;
                      }
                    }}
                  />
                </div>

                {/* Clean Teaser Content - Without Overwhelming Details */}
                <div className="house-card-teaser-body">
                  <div className="house-card-teaser-badge-row">
                    <span
                      className="house-card-teaser-badge"
                      style={{
                        backgroundColor: theme.badgeBg,
                        borderColor: theme.color,
                        color: theme.accentColor
                      }}
                    >
                      <i className={`fas ${theme.icon}`} style={{ color: theme.color }} aria-hidden="true" />
                      <span>{(house.name || '').replace('House of ', '')}</span>
                    </span>
                  </div>

                  <h3 className="house-card-name">{house.name}</h3>

                  {house.motto && house.motto !== 'null' && house.motto !== 'undefined' && (
                    <p className="house-card-motto">"{house.motto}"</p>
                  )}

                  {/* Call to Action Button encouraging click to Detail Page */}
                  <div className="house-card-teaser-action">
                    <span
                      className="house-action-pill-btn"
                      style={{
                        borderColor: theme.color,
                        boxShadow: `0 4px 14px ${theme.glow}`
                      }}
                    >
                      <span>Explore House Details</span>
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>



      <section className="wellbeing-section" id="wellbeing-sel">
        {/* Section Header */}
        <div className="wellbeing-header">
          <div className="wellbeing-kicker-wrap">
            <span className="wellbeing-kicker-badge">
              <span className="wellbeing-kicker-dot" />
              <span>{wellbeing.kicker && wellbeing.kicker !== 'null' && wellbeing.kicker !== 'undefined' ? wellbeing.kicker : 'Wellbeing & Social Emotional Learning'}</span>
            </span>
          </div>

          <h2 className="wellbeing-title">
            {wellbeing.title && wellbeing.title !== 'null' && wellbeing.title !== 'undefined' ? wellbeing.title : 'Support for emotional and academic growth'}
          </h2>

          <p className="wellbeing-desc">
            {wellbeing.description && wellbeing.description !== 'null' && wellbeing.description !== 'undefined' ? wellbeing.description : 'Our SEL framework helps students build resilience, confidence, and healthy relationships while supporting academic success. Dedicated counselors, advisory teachers, and structured lessons ensure every student feels seen and supported.'}
          </p>
        </div>

        {/* Stage 1: Balanced 2-Column Hero (Core SEL Pillars Card + HD Gallery) */}
        <div className="wellbeing-hero-grid">
          {/* Left: Core SEL Pillars Master Card */}
          <div className="wellbeing-pillars-card">
            <div className="wellbeing-pillars-ribbon" />

            <div className="wellbeing-pillars-card-head">
              <span className="wellbeing-pillars-cat-badge">
                <i className="fas fa-seedling" aria-hidden="true" />
                <span>Foundational SEL Framework</span>
              </span>
              <h3 className="wellbeing-pillars-heading">Core Competencies</h3>
              <p className="wellbeing-pillars-subtext">
                Essential social and emotional competencies cultivated through daily routines, mentorship, and guided reflections.
              </p>
            </div>

            <div className="wellbeing-pillars-grid">
              {wellbeing.pillars.map((pillar, pIdx) => {
                const pillarName = typeof pillar === 'string' ? pillar : (pillar?.name || pillar?.title || '');
                if (!pillarName || pillarName === 'null' || pillarName === 'undefined') return null;
                const iconClass = getPillarIcon(pillar);
                return (
                  <div className="wellbeing-pillar-item" key={pIdx}>
                    <span className="wellbeing-pillar-number">
                      {String(pIdx + 1).padStart(2, '0')}
                    </span>
                    <div className="wellbeing-pillar-icon-wrap">
                      <i className={`fas ${iconClass}`} aria-hidden="true" />
                    </div>
                    <span className="wellbeing-pillar-name">{pillarName}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right: High-Definition Photographic Gallery Carousel */}
          <div className="wellbeing-gallery-frame" aria-label="Wellbeing and Student Care gallery">
            {wellbeing.images.map((image, imgIdx) => (
              <div
                key={`wb-gallery-${imgIdx}`}
                className={`wellbeing-gallery-slide ${imgIdx === activeWellbeingSlide ? 'active' : ''}`}
              >
                <img
                  src={image}
                  alt={`Wellbeing moment ${imgIdx + 1}`}
                  className="wellbeing-gallery-img"
                  onError={(e) => {
                    const fb = [wellbeingSEL1, wellbeingSEL2, wellbeingSEL3][imgIdx % 3] || wellbeingSEL1;
                    if (e.currentTarget.src !== fb) {
                      e.currentTarget.src = fb;
                    }
                  }}
                />
              </div>
            ))}

            <div className="wellbeing-gallery-overlay" aria-hidden="true" />

            {/* Floating Counter Badge */}
            {wellbeing.images.length > 0 && (
              <div className="wellbeing-gallery-counter">
                <i className="fas fa-camera" aria-hidden="true" />
                <span>{activeWellbeingSlide + 1} / {wellbeing.images.length}</span>
              </div>
            )}

            {/* Floating Prev/Next Navigation Controls */}
            {wellbeing.images.length > 1 && (
              <>
                <button
                  type="button"
                  className="wellbeing-nav-btn wellbeing-nav-prev"
                  onClick={() => prevWellbeingSlide(wellbeing.images.length)}
                  aria-label="Previous wellbeing photo"
                >
                  <i className="fas fa-chevron-left" />
                </button>
                <button
                  type="button"
                  className="wellbeing-nav-btn wellbeing-nav-next"
                  onClick={() => nextWellbeingSlide(wellbeing.images.length)}
                  aria-label="Next wellbeing photo"
                >
                  <i className="fas fa-chevron-right" />
                </button>
              </>
            )}

            {/* Floating Bottom Dots Bar */}
            {wellbeing.images.length > 1 && (
              <div className="wellbeing-gallery-dots" role="tablist" aria-label="Wellbeing slide dots">
                {wellbeing.images.map((_, dotIdx) => (
                  <button
                    key={dotIdx}
                    type="button"
                    className={`wellbeing-gallery-dot ${dotIdx === activeWellbeingSlide ? 'active' : ''}`}
                    onClick={() => setActiveWellbeingSlide(dotIdx)}
                    aria-label={`Show slide ${dotIdx + 1}`}
                    role="tab"
                    aria-selected={dotIdx === activeWellbeingSlide}
                  >
                    <span className="wellbeing-dot-bar" />
                  </button>
                ))}
              </div>
            )}

            {/* Floating Caption Card */}
            <div className="wellbeing-gallery-caption">
              <div className="wellbeing-caption-tag">
                <span className="wellbeing-caption-dot" />
                <span>Nurturing Campus Culture</span>
              </div>
              <p className="wellbeing-caption-text">
                Comprehensive pastoral care and dedicated advisory teams supporting each student's journey.
              </p>
            </div>
          </div>
        </div>

        {/* Stage 2: Symmetrical Multi-Column Pathways Grid (Dynamic & Stable) */}
        <div className="wellbeing-pathways-section">
          <div className="wellbeing-pathways-header">
            <span className="wellbeing-pathways-kicker">
              <i className="fas fa-compass" aria-hidden="true" />
              <span>Integrated Support Network</span>
            </span>
            <h3 className="wellbeing-pathways-title">Personalized Care Pathways</h3>
            <p className="wellbeing-pathways-desc">
              Individualized mentorship, academic coaching, and family collaboration to ensure every student flourishes.
            </p>
          </div>

          <div className="wellbeing-pathways-grid">
            {wellbeing.supports.map((support, sIdx) => {
              if (!support || typeof support !== 'object') return null;
              const title = support.title && support.title !== 'null' && support.title !== 'undefined' ? support.title : '';
              const detail = support.detail && support.detail !== 'null' && support.detail !== 'undefined' ? support.detail : '';
              if (!title && !detail) return null;
              const iconClass = getSupportIcon(support);
              return (
                <div
                  key={title || sIdx}
                  className="wellbeing-pathway-card"
                >
                  <div className="wellbeing-card-ribbon" />

                  <div className="wellbeing-pathway-card-top">
                    <div className="wellbeing-pathway-icon">
                      <i className={`fas ${iconClass}`} aria-hidden="true" />
                    </div>
                    <span className="wellbeing-pathway-step-pill">
                      Pathway {String(sIdx + 1).padStart(2, '0')}
                    </span>
                  </div>

                  <h4 className="wellbeing-pathway-title">{title}</h4>
                  <p className="wellbeing-pathway-detail">{detail}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>



      <section className="character-shaping-section" id="character-shaping">
        {/* Section Header */}
        <div className="character-shaping-header">
          <div className="character-shaping-kicker-wrap">
            <span className="character-shaping-kicker-badge">
              <span className="character-shaping-kicker-dot" />
              <span>{characterShapingSec?.kicker && characterShapingSec.kicker !== 'null' && characterShapingSec.kicker !== 'undefined' ? characterShapingSec.kicker : 'Our Framework'}</span>
            </span>
          </div>

          <h2 className="character-shaping-title">
            {characterShapingSec?.title && characterShapingSec.title !== 'null' && characterShapingSec.title !== 'undefined' ? characterShapingSec.title : 'Character Shaping Program'}
          </h2>

          <p className="character-shaping-desc">
            {characterShapingSec?.description && characterShapingSec.description !== 'null' && characterShapingSec.description !== 'undefined' ? characterShapingSec.description : 'A holistic approach to student development built on three interconnected botanical pillars: Eastern Culture values as our roots, Social Emotional Learning as our sturdy trunk, and Wellbeing as our flourishing fruits.'}
          </p>
        </div>

        {/* Grand Tree Central Showcase */}
        <div className="tree-grand-showcase">
          <div className="tree-hero-pedestal">
            <img
              src={treeImage}
              alt="Character Shaping Program Tree: Roots, Trunk, and Fruits"
              className="tree-hero-image"
            />

            {/* Hotspot 1: The Fruits (Wellbeing) - Top Canopy */}
            <button
              type="button"
              className={`tree-hero-hotspot hotspot-fruits ${activeTreeZone === 'wellbeing' ? 'active-hotspot' : ''}`}
              onClick={() => openTreeModal('wellbeing')}
              aria-label="Explore Wellbeing (The Fruits)"
            >
              <span className="hotspot-pulse" />
              <span className="hotspot-pill">
                <i className="fas fa-apple-whole" aria-hidden="true" />
                <span className="hotspot-text-wrap">
                  <span className="hotspot-tag">The Fruits</span>
                  <span className="hotspot-name">{treeZoneContent.wellbeing?.title || 'Wellbeing'}</span>
                </span>
                <i className="fas fa-chevron-right hotspot-arrow" aria-hidden="true" />
              </span>
            </button>

            {/* Hotspot 2: The Trunk (SEL) - Center Trunk */}
            <button
              type="button"
              className={`tree-hero-hotspot hotspot-trunk ${activeTreeZone === 'sel' ? 'active-hotspot' : ''}`}
              onClick={() => openTreeModal('sel')}
              aria-label="Explore Social Emotional Learning (The Trunk)"
            >
              <span className="hotspot-pulse" />
              <span className="hotspot-pill">
                <i className="fas fa-brain" aria-hidden="true" />
                <span className="hotspot-text-wrap">
                  <span className="hotspot-tag">The Trunk</span>
                  <span className="hotspot-name">{treeZoneContent.sel?.title || 'Social Emotional Learning'}</span>
                </span>
                <i className="fas fa-chevron-right hotspot-arrow" aria-hidden="true" />
              </span>
            </button>

            {/* Hotspot 3: The Roots (Eastern Culture) - Base Roots */}
            <button
              type="button"
              className={`tree-hero-hotspot hotspot-roots ${activeTreeZone === 'easternCulture' ? 'active-hotspot' : ''}`}
              onClick={() => openTreeModal('easternCulture')}
              aria-label="Explore Eastern Culture Values (The Roots)"
            >
              <span className="hotspot-pulse" />
              <span className="hotspot-pill">
                <i className="fas fa-leaf" aria-hidden="true" />
                <span className="hotspot-text-wrap">
                  <span className="hotspot-tag">The Roots</span>
                  <span className="hotspot-name">{treeZoneContent.easternCulture?.title || 'Eastern Culture Values'}</span>
                </span>
                <i className="fas fa-chevron-right hotspot-arrow" aria-hidden="true" />
              </span>
            </button>
          </div>

          <div className="tree-hero-hint">
            <i className="fas fa-hand-pointer" aria-hidden="true" />
            <span>Click any tier on the tree (The Roots, The Trunk, or The Fruits) to view the complete curriculum</span>
          </div>
        </div>

        {/* 3 Executive Tier Overview Cards */}
        <div className="tree-tier-summary-grid">
          {[
            {
              key: 'easternCulture',
              level: 'LEVEL 01',
              metaphor: 'The Roots',
              badge: 'FOUNDATION',
              title: treeZoneContent.easternCulture?.title || 'Eastern Culture Values',
              desc: treeZoneContent.easternCulture?.subtitle || 'Moral bedrock, respect for elders, filial piety, humility, and self-discipline anchoring every student.',
              icon: 'fa-leaf'
            },
            {
              key: 'sel',
              level: 'LEVEL 02',
              metaphor: 'The Trunk',
              badge: 'GROWTH STRUCTURE',
              title: treeZoneContent.sel?.title || 'Social Emotional Learning',
              desc: treeZoneContent.sel?.subtitle || 'Essential soft skills, emotional regulation, empathy, self-awareness, and constructive decision-making.',
              icon: 'fa-brain'
            },
            {
              key: 'wellbeing',
              level: 'LEVEL 03',
              metaphor: 'The Fruits',
              badge: 'FLOURISHING OUTCOME',
              title: treeZoneContent.wellbeing?.title || 'Holistic Wellbeing',
              desc: treeZoneContent.wellbeing?.subtitle || 'Flourishing physical vitality, social harmony, emotional resilience, and lifelong academic growth.',
              icon: 'fa-apple-whole'
            }
          ].map((item) => (
            <div
              key={item.key}
              className="tree-tier-card"
              onClick={() => openTreeModal(item.key)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  openTreeModal(item.key);
                }
              }}
              aria-label={`Explore ${item.title} (${item.metaphor})`}
            >
              <div className="tier-card-ribbon" />

              <div className="tier-card-top">
                <span className="tier-card-badge">{item.level} • {item.badge}</span>
                <div className="tier-card-icon">
                  <i className={`fas ${item.icon}`} aria-hidden="true" />
                </div>
              </div>

              <span className="tier-card-metaphor">{item.metaphor}</span>
              <h3 className="tier-card-title">{item.title}</h3>
              <p className="tier-card-desc">{item.desc}</p>

              <div className="tier-card-btn">
                <span>View {item.metaphor} Curriculum</span>
                <i className="fas fa-arrow-right" aria-hidden="true" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Ultra-Wide Panoramic Manifesto Modal */}
      {showTreeModal && (
        <div
          className="panoramic-tree-modal-overlay"
          onClick={() => setShowTreeModal(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="panoramic-tree-modal-title"
        >
          <div
            className="panoramic-tree-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Multi-tone Prestige Gold Ribbon */}
            <div className="tier-card-ribbon" />

            {/* Streamlined Panoramic Header (Single Unified Bar) */}
            <div className="panoramic-modal-header">
              <div className="panoramic-header-left">
                <div className="panoramic-header-icon">
                  <i className={`fas ${getTreeMetaphorMeta(activeTreeZone).icon}`} aria-hidden="true" />
                </div>
                <div className="panoramic-header-text">
                  <div className="panoramic-header-badges">
                    <span className="panoramic-level-badge">
                      {getTreeMetaphorMeta(activeTreeZone).level}
                    </span>
                    <span className="panoramic-count-badge">
                      {treeZoneContent[activeTreeZone]?.content?.length || 0} Core Competencies
                    </span>
                  </div>
                  <h3 id="panoramic-tree-modal-title" className="panoramic-modal-title">
                    {treeZoneContent[activeTreeZone]?.title}
                  </h3>
                  <p className="panoramic-modal-subtitle">
                    {treeZoneContent[activeTreeZone]?.subtitle}
                  </p>
                </div>
              </div>

              <div className="panoramic-header-right">
                {/* Internal Tier Switcher Tabs */}
                <div className="panoramic-tabs-bar" role="tablist" aria-label="Framework Pillars">
                  {[
                    { key: 'easternCulture', label: 'The Roots', fullLabel: 'The Roots: Eastern Culture', icon: 'fa-leaf' },
                    { key: 'sel', label: 'The Trunk', fullLabel: 'The Trunk: Social Emotional Learning', icon: 'fa-brain' },
                    { key: 'wellbeing', label: 'The Fruits', fullLabel: 'The Fruits: Wellbeing', icon: 'fa-apple-whole' },
                  ].map((mTab) => (
                    <button
                      key={mTab.key}
                      type="button"
                      className={`panoramic-tab-btn ${activeTreeZone === mTab.key ? 'active' : ''}`}
                      onClick={() => handleSelectModalTab(mTab.key)}
                      role="tab"
                      aria-selected={activeTreeZone === mTab.key}
                      title={mTab.fullLabel}
                    >
                      <i className={`fas ${mTab.icon}`} aria-hidden="true" />
                      <span>{mTab.label}</span>
                    </button>
                  ))}
                </div>

                {/* Close Button */}
                <button
                  type="button"
                  className="panoramic-modal-close"
                  onClick={() => setShowTreeModal(false)}
                  aria-label="Close Character Shaping modal"
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            </div>

            {/* Expansive, Spacious Panoramic Content Body */}
            <div className="panoramic-modal-body" ref={modalBodyRef}>
              <div className="panoramic-pillars-grid">
                {treeZoneContent[activeTreeZone]?.content?.map((pillar, pIdx) => (
                  <div key={pillar.heading || pIdx} className="panoramic-pillar-card">
                    <div className="panoramic-card-ribbon" />
                    <div className="panoramic-card-head">
                      <span className="panoramic-card-num">
                        {String(pIdx + 1).padStart(2, '0')}
                      </span>
                      <h4 className="panoramic-card-title">{pillar.heading}</h4>
                    </div>

                    <ul className="panoramic-card-list">
                      {(pillar.points || []).map((pt, ptIdx) => (
                        <li key={ptIdx} className="panoramic-card-item">
                          <span className="panoramic-item-icon">
                            <i className="fas fa-check" aria-hidden="true" />
                          </span>
                          <span className="panoramic-item-text">
                            {typeof pt === 'string' ? pt : (pt?.text || pt?.title || String(pt))}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            {/* Seamless Dark Royal Purple Footer */}
            <div className="panoramic-modal-footer">
              <div className="panoramic-footer-info">
                <i className="fas fa-seedling" aria-hidden="true" />
                <span>Interconnected Botanical Framework: Moral Roots, Sturdy Trunk, Flourishing Fruits</span>
              </div>
              <button
                type="button"
                className="panoramic-footer-close"
                onClick={() => setShowTreeModal(false)}
              >
                <span>Close Manifesto</span>
                <i className="fas fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Section 7: Student Development (LEAPS Framework Flip Cards) */}
      <section className="leaps-section" id="leaps">
        <div className="leaps-container">
          <div className="leaps-header">
            <div className="leaps-kicker-wrap">
              <span className="leaps-kicker-badge">
                <span className="leaps-kicker-dot" />
                <span>{leaps.kicker}</span>
              </span>
            </div>
            <h2 className="leaps-title">{leaps.title}</h2>
            <p className="leaps-desc">{leaps.description}</p>
          </div>

          <div className="leaps-grid life-animate">
            {leaps.items.map((item, index) => (
              <div
                key={item.letter}
                className={`leaps-card ${flippedLeapsCard === item.letter ? 'flipped' : ''}`}
                style={{ '--card-color': item.color }}
                onClick={() => setFlippedLeapsCard(prev => prev === item.letter ? null : item.letter)}
                role="button"
                tabIndex={0}
                aria-label={`${item.fullText} card. Click or tap to flip.`}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setFlippedLeapsCard(prev => prev === item.letter ? null : item.letter);
                  }
                }}
              >
                <div className="leaps-card-inner">
                  {/* Front of Card: High-Contrast Champagne Pearl Surface */}
                  <div className="leaps-card-front">
                    <div className="leaps-front-ribbon" />
                    <div className="leaps-front-top">
                      <span className="leaps-dimension-pill">
                        DIMENSION {String(index + 1).padStart(2, '0')}
                      </span>
                      <div className="leaps-front-mini-icon">
                        <i className={`fas ${item.icon}`} aria-hidden="true" />
                      </div>
                    </div>

                    <div className="leaps-letter-wrap">
                      <span className="leaps-letter">{item.letter}</span>
                      <span className="leaps-letter-shadow" aria-hidden="true">{item.letter}</span>
                    </div>

                    <div className="leaps-front-bottom">
                      <h4 className="leaps-front-title">{item.fullText}</h4>
                      <div className="leaps-flip-hint">
                        <span>Tap to reveal</span>
                        <i className="fas fa-arrow-rotate-right" aria-hidden="true" />
                      </div>
                    </div>
                  </div>

                  {/* Back of Card: Radiant Jewel Gradient with Complete Details */}
                  <div className="leaps-card-back">
                    <div className="leaps-back-ribbon" />
                    <div className="leaps-back-content">
                      <div className="leaps-back-icon-box">
                        <i className={`fas ${item.icon}`} aria-hidden="true" />
                      </div>

                      <span className="leaps-back-badge">
                        DIMENSION {String(index + 1).padStart(2, '0')}
                      </span>

                      <h4 className="leaps-back-title">{item.fullText}</h4>
                      <p className="leaps-back-desc">{item.description}</p>

                      <div className="leaps-back-flip-btn">
                        <span>Flip back</span>
                        <i className="fas fa-arrow-rotate-left" aria-hidden="true" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="leaps-footer-hint">
            <i className="fas fa-hand-pointer" aria-hidden="true" />
            <span>Click or hover on any dimension card above to view full developmental details</span>
          </div>
        </div>
      </section>

    </section>

  );

}



export default StudentLifePage;

